import { render, staticRenderFns } from "./HeaderFooterCustom.vue?vue&type=template&id=7d2dfb76"
import script from "./HeaderFooterCustom.vue?vue&type=script&lang=js"
export * from "./HeaderFooterCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports